import { ofetch, type FetchOptions } from "ofetch";
import { jwtDecode } from "jwt-decode";

import ModuleApi from "./modulo";
import ChamadaSenhaApi from "./chamadaSenha";
import PermissionApi from "./permissao";
import ReportApi from "./relatorio";
import CustomReportApi from "./relatorio_custom";
import DashboardApi from "./dashboard";
import PrintApi from "./impressao";
import AcessoApi from "./acesso";
import UfApi from "./uf";
import EmissorApi from "./emissor";
import TomadorApi from "./tomador";
import ContratadoApi from "./contratado";
import OperadoraApi from "./operadora";
import NFSeApi from "./nfe";
import SiteGeralApi from "./siteGeral";
import PacienteApi from "./paciente";
import TelefoneApi from "./telefone";
import AtivarCertificadoApi from "./ativarCertificado";
import IntermediarioApi from "./intermediario";
import FaturamentoApi from "./faturamento";
import MedicoApi from "./medico";
import AgendamentoApi from "./agendamento";
import CidApi from "./cid";
import ConfiguracaoApi from "./configuracao";
import DespesaExecucaoApi from "./despesaExecucao";
import ExecucaoApi from "./execucao";
import GuiaApi from "./guia";
import MedicoConselhoProfissionalApi from "./medicoConselhoProf";
import ProtocoloGuia from "./protocoloGuia";
import PlanoApi from "./plano";
import ProcedimentoApi from "./procedimento";
import ProcedimentoPlanoOperadoraApi from "./procedimentoPlanoOperadora";
import Unidade from "./unidade";
import AgendaApi from "./agenda";
import DiagnosticoApi from "./diagnostico";
import AgendamentoWebApi from "./webAgendamento";
import IniApi from "./ini";
import CentralNotificacaoApi from "./centralNotificacao";
import TotemSenhaApi from "./totem";
import TelaoApi from "./telao";
import RssApi from "./rss";
import VersaoApi from "./versao";
import TTSApi from "./tts";
import EditorTelaoApi from "./editorTelao";
import AvaliacaoApi from "./avaliacao";
import ValidacaoApi from "./validacao";
import MedwareApi from "./medware";

interface ApiOptions {
  passiveAuth?: boolean;
}

export default class Api {
  constructor(private readonly options: ApiOptions = {}) {}

  /** @returns instância da API do domínio Medware. */
  public getMedwareApi() {
    return new MedwareApi(this.getApi());
  }

  public getValidacaoApi() {
    return new ValidacaoApi(this.getApi());
  }

  public getAvaliacaoApi() {
    return new AvaliacaoApi(this.getApi());
  }

  public getAgendamentoWebApi() {
    return new AgendamentoWebApi(this.getApi());
  }
  public getCentralNotificacaoApi() {
    return new CentralNotificacaoApi(this.getApi());
  }
  public getVersaoApi() {
    return new VersaoApi(this.getApi());
  }
  public getTTSApi() {
    return new TTSApi(this.getApi());
  }
  public getRssApi() {
    return new RssApi(this.getApi());
  }
  public getChamadaSenhaApi() {
    return new ChamadaSenhaApi(this.getApi());
  }

  public getTotemSenhaApi() {
    return new TotemSenhaApi(this.getApi());
  }

  public getTelaoApi() {
    return new TelaoApi(this.getApi());
  }
  public getEditorTelaoApi() {
    return new EditorTelaoApi(this.getApi());
  }
  public getIniApi() {
    return new IniApi(this.getApi());
  }
  public getProtocoloGuiaApi() {
    return new ProtocoloGuia(this.getApi());
  }
  public getFaturamentoApi() {
    return new FaturamentoApi(this.getApi());
  }
  public getDiagnosticoApi() {
    return new DiagnosticoApi(this.getApi());
  }

  public getMedicoApi() {
    return new MedicoApi(this.getApi());
  }
  public getAgendamentoApi() {
    return new AgendamentoApi(this.getApi());
  }
  public getCidApi() {
    return new CidApi(this.getApi());
  }
  public getConfiguracaoApi() {
    return new ConfiguracaoApi(this.getApi());
  }
  public getDespesaExecucaoApi() {
    return new DespesaExecucaoApi(this.getApi());
  }
  public getExecucaoApi() {
    return new ExecucaoApi(this.getApi());
  }
  public getGuiaApi() {
    return new GuiaApi(this.getApi());
  }
  public getMedicoConselhoProfissionalApi() {
    return new MedicoConselhoProfissionalApi(this.getApi());
  }
  public getPlanoApi() {
    return new PlanoApi(this.getApi());
  }
  public getProcedimentoApi() {
    return new ProcedimentoApi(this.getApi());
  }
  public getProcedimentoPlanoOperadoraApi() {
    return new ProcedimentoPlanoOperadoraApi(this.getApi());
  }
  public getUnidade() {
    return new Unidade(this.getApi());
  }
  public getAgendaApi() {
    return new AgendaApi(this.getApi());
  }
  /**
   * @returns instância da classe AtivarCertificadoApi
   */
  public getAtivarCertificadoApi() {
    return new AtivarCertificadoApi(this.getApi());
  }

  /**
   * @returns instância da classe ModuleApi
   */
  public getModuleApi() {
    return new ModuleApi(this.getApi());
  }

  /**
   * @returns instância da classe ModuleApi
   */
  public getPermissionApi() {
    return new PermissionApi(this.getApi());
  }

  /**
   * @returns instância da classe ReportApi
   */
  public getReportApi() {
    return new ReportApi(this.getApi());
  }

  /**
   * @returns instância da classe NfeApi
   */
  public getNFSeApi() {
    return new NFSeApi(this.getApi());
  }

  /**
   * @returns instância da classe SiteGeralApi
   */
  public getSiteGeralApi() {
    return new SiteGeralApi(this.getApi());
  }

  /**
   * @returns instância da classe EmissorApi
   */
  public getEmissorApi() {
    return new EmissorApi(this.getApi());
  }

  public getIntermediarioApi() {
    return new IntermediarioApi(this.getApi());
  }

  /**
   * @returns instância da classe TelefoneApi
   */
  public getTelefoneApi() {
    return new TelefoneApi(this.getApi());
  }

  /**
   * @returns instância da classe PacienteApi
   */
  public getPacienteApi() {
    return new PacienteApi(this.getApi());
  }
  /**
   * @returns instância da classe TomadorApi
   */
  public getTomadorApi() {
    return new TomadorApi(this.getApi());
  }
  /**
   * @returns instância da classe UfApi
   */
  public getUfApi() {
    return new UfApi(this.getApi());
  }
  /**
   * @returns instância da classe UfApi
   */
  public getContratadoApi() {
    return new ContratadoApi(this.getApi());
  }
  /**
   * @returns instância da classe UfApi
   */
  public getOperadoraApi() {
    return new OperadoraApi(this.getApi());
  }
  /**
   * @returns instância da classe CustomReportApi
   */
  public getCustomReportApi() {
    return new CustomReportApi(this.getApi());
  }
  /**
   * @returns instância da classe DashboardApi
   */
  public getDashboardApi() {
    return new DashboardApi(this.getApi());
  }
  /**
   * @returns instância da classe PrintApi
   */
  public getPrintApi() {
    return new PrintApi(this.getApi());
  }
  /**
   * @returns instância da classe AcessoApi
   */
  public getAcessoApi() {
    return new AcessoApi(this.getApi(), this.getBaseUrl());
  }
  /**
   * @returns a instância do ofetch com as configurações globais
   */
  private getApi() {
    return ofetch.create(this.getOptions());
  }

  public getBaseUrl() {
    const config = useRuntimeConfig();
    const isDev = import.meta.dev || process.env?.["NODE_ENV"] === "development";
    return !isDev ? `${location.origin}/api` : config.public.apiBase;
  }

  /**
   * @returns token de autenticação armazenado no cookie
   */
  private getToken() {
    let token = "";
    token = localStorage.getItem("token") ?? "";
    return token?.includes("Bearer") ? token : `Bearer ${token}`;
  }

  private getTokenPin() {
    let token = "";
    token = localStorage.getItem("tokenPin") ?? "";
    return token;
  }

  /**
   * Verifica se o token JWT é válido
   * @returns true se o token for válido, false caso contrário
   */
  private geterifyToken() {
    const token = localStorage.getItem("token") ?? "";
    const tokenWithoutBearer = token.includes("Bearer")
      ? token.replace("Bearer ", "")
      : token;
    try {
      const decodedToken = jwtDecode(tokenWithoutBearer);
      if (decodedToken && typeof decodedToken.exp === "number") {
        const currentTimestamp = Math.floor(Date.now() / 1000);
        return decodedToken.exp > currentTimestamp;
      }
      return false;
    } catch (error) {
      return false;
    }
  }

  /**
   * @returns opções globais da instância do ofetch
   */
  private getOptions(): FetchOptions {
    const url = this.getBaseUrl();
    const token = this.getToken();
    const passiveAuth = this.options.passiveAuth === true;
    return {
      baseURL: url,
      headers: {
        Accept: "application/json",
        Authorization: token,
      },
      retry: 3,
      retryDelay: 40000,
      async onRequest({ request, options }) {
        const verifyToken = () => {
          const token = localStorage.getItem("token") ?? "";
          const tokenWithoutBearer = token.includes("Bearer")
            ? token.replace("Bearer ", "")
            : token;
          try {
            const decodedToken = jwtDecode(tokenWithoutBearer);
            if (decodedToken && typeof decodedToken.exp === "number") {
              const currentTimestamp = Math.floor(Date.now() / 1000);
              return currentTimestamp > decodedToken.exp;
            }
            return false;
          } catch (error) {
            return false;
          }
        };

        if (!passiveAuth && verifyToken()) {
          const authTokenStore = localStorage
            .getItem("token")
            ?.includes("Bearer")
            ? localStorage.getItem("token")?.replace("Bearer ", "")
            : localStorage.getItem("token");
          const authRfToken = localStorage.getItem("rfToken");
          const resp = await ofetch<{ refreshToken: string; token: string }>(
            `${url}/Acesso/refreshToken?refreshToken=${authRfToken}&token=${authTokenStore}`,
            {
              method: "POST",
            },
          );
          if (resp?.token && resp?.refreshToken) {
            localStorage.setItem("token", `${resp?.token}`);
            localStorage.setItem("rfToken", `${resp?.refreshToken}`);
            location.reload();
          } else {
            localStorage.clear();
            navigateTo("/login");
          }
        }

        if (!(options.headers instanceof Headers)) {
          options.headers = new Headers(
            options.headers as Record<string, string>,
          );
        }

        const isFormData = options.body instanceof FormData;

        if (isFormData) {
          options.headers.delete("Content-Type");
        } else if (options.body) {
          options.headers.set("Content-Type", "application/json");
        }
      },
      onRequestError: passiveAuth ? undefined : this.onRequestError,
      onResponseError: passiveAuth ? undefined : this.onResponseError,
      onResponse(context) {
        if (!passiveAuth && context.response.redirected) {
          window.location.href = url + "/Home/Index";
        }
      },
    };
  }

  /**
   * Middleware de gerenciamento de erros de requisição
   * @returns objeto de request
   */
  private onRequestError({ request, options, error }: any) {
    // eslint-disable-next-line no-console
    console.error("[fetch request error]", request, error, options);

    return request;
  }

  /**
   * Middleware de gerenciamento de erros de resposta
   * @returns objeto de response
   */
  private onResponseError({ request, response }: any) {
    // eslint-disable-next-line no-console
    console.error(
      "[fetch response error]",
      request,
      response,
      // response.status,
      // response.body,
      // options,
    );

    return response;
  }
}
